// TODO: It's likely that this store will be removed in the future, but for now it's here to keep track of the theme

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export enum ChatTheme {
  Dark = 'federal-theme',
  Light = 'scale-theme',
}

export type ChatThemeStore = {
  theme: ChatTheme;
  setTheme: (theme: ChatTheme) => void;
  isFirstVisit: boolean;
  setIsFirstVisit: (isFirstVisit: boolean) => void;
};

export const useChatThemeStore = create<ChatThemeStore>()(
  persist(
    set => ({
      theme: ChatTheme.Light,
      setTheme: (theme: ChatTheme) => {
        set({ theme, isFirstVisit: false });
      },
      isFirstVisit: true,
      setIsFirstVisit: (isFirstVisit: boolean) => {
        set({ isFirstVisit });
      },
    }),
    {
      name: 'chat-theme-store',
    },
  ),
);
